import { useEffect, isValidElement } from 'react';
import styled, { css } from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import Heading from '../Heading/Heading.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import SvgIcon from '../SvgIcon/SvgIcon.js';

const Drawer = props => {
  const {
    open,
    onClose,
    children,
    side,
    backgroundColor,
    width,
    disableBackground,
    testID,
    title
  } = props;
  useEffect(() => {
    if (typeof document !== 'undefined' && open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [open]);
  useEffect(() => {
    return () => {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = 'unset';
      }
    };
  }, []);
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsx(AnimatePresence, {
      children: open && /*#__PURE__*/jsx("div", {
        "data-testid": testID,
        children: /*#__PURE__*/jsx(Backdrop, {
          "data-testid": "backdrop-test",
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1
          },
          transition: {
            duration: 0.3
          },
          exit: {
            opacity: 0
          },
          onClick: onClose,
          side: side,
          $disableBackground: disableBackground,
          children: /*#__PURE__*/jsxs(PanelContainer, {
            "data-testid": "panel-test",
            initial: {
              opacity: 0,
              x: side === 'left' ? '-100%' : '100%'
            },
            animate: {
              x: 0,
              opacity: 1
            },
            transition: {
              duration: 0.4,
              ease: 'easeOut'
            },
            exit: {
              opacity: 0,
              x: side === 'left' ? '-100%' : '100%'
            },
            onClick: e => e.stopPropagation(),
            $backgroundColor: backgroundColor,
            width: width,
            children: [/*#__PURE__*/jsxs(DrawerHeader, {
              side: side,
              children: [/*#__PURE__*/isValidElement(title) ? /*#__PURE__*/jsx(Fragment, {
                children: title
              }) : /*#__PURE__*/jsx(Heading, {
                testID: 'drawer-header-title',
                element: 'h5',
                children: title
              }), /*#__PURE__*/jsx(StyledCloseBtn, {
                onClick: onClose,
                children: /*#__PURE__*/jsx(SvgIcon, {
                  type: "close"
                })
              })]
            }), /*#__PURE__*/jsx("div", {
              children: children
            })]
          })
        })
      })
    })
  });
};
const Backdrop = styled(motion.div)`
  position: fixed;
  z-index: 2200000000;
  display: flex;
  background-color: ${_ref => {
  let {
    $disableBackground
  } = _ref;
  return $disableBackground ? 'transparent' : 'rgba(0 0 0 / 50%)';
}};
  inset: 0;

  ${_ref2 => {
  let {
    side
  } = _ref2;
  return side === 'right' && css`justify-content: flex-end;`;
}}
`;
const PanelContainer = styled(motion.div)`
  width: 100%;
  height: 100%;
  padding: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing[7];
}};
  overflow: auto;
  background: ${_ref4 => {
  let {
    $backgroundColor
  } = _ref4;
  return $backgroundColor;
}};

  @media screen and (min-width: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.screen.sm;
}}) {
    width: ${_ref6 => {
  let {
    width
  } = _ref6;
  return width > 100 ? '100%' : `${width}%`;
}};
  }
`;
const StyledCloseBtn = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 44px;
  height: 44px;
  cursor: pointer;
`;
const DrawerHeader = styled.div`
  align-items: center;
  flex-direction: ${_ref7 => {
  let {
    side
  } = _ref7;
  return side === 'left' ? 'row-reverse' : 'row';
}};
  justify-content: space-between;
  display: flex;
`;
Drawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  side: PropTypes.oneOf(['left', 'right']),
  backgroundColor: PropTypes.string,
  width: PropTypes.number,
  disableBackground: PropTypes.bool,
  testID: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
Drawer.defaultProps = {
  children: null,
  side: 'right',
  backgroundColor: 'white',
  width: 25,
  disableBackground: false,
  testID: 'drawer-test',
  title: undefined
};
var Drawer$1 = Drawer;

export { Drawer$1 as default };
//# sourceMappingURL=Drawer.js.map
